import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb as Bc } from 'antd'

type item = {
  name: string
  url: string
}
interface Props {
  data: item[]
  className?: string
  style?: React.CSSProperties
}
const Breadcrumb = ({ data, className, style }: Props) => {
  const ustyle = style || { margin: '22px 0' }
  return (
    <Bc className={className} separator=">" style={ustyle}>
      {data.map(({ name, url }, idx) => (
        <Bc.Item key={idx}>
          <span style={{ color: '#999' }}>
            {url ? <Link to={url} style={{ color: '#333' }}>{name}</Link> : name}
          </span>
        </Bc.Item>
      ))}
    </Bc>
  )
}

export default Breadcrumb
